export function SplashScreen({ label = 'Загрузка' }: { label?: string }) {
  return (
    <div className="splash-screen" role="status" aria-live="polite" aria-label={label}>
      <div className="splash-mark">
        <span className="splash-ring" aria-hidden />
        <span className="splash-dot" aria-hidden />
      </div>
      <p className="splash-brand">Твой провайдер</p>
    </div>
  );
}
